import {
  BreadcrumbItem as _BreadcrumbItem,
  Breadcrumb as _Breadcrumb,
  BreadcrumbProps as _BreadcrumbProps,
  BreadcrumbItemProps as _BreadcrumbItemProps,
} from "reactstrap";

export const Breadcrumb = _Breadcrumb;
export const BreadcrumbItem = _BreadcrumbItem;
export type BreadcrumbProps = _BreadcrumbProps;
export type BreadcrumbItemProps = _BreadcrumbItemProps;
